
const services = [
  {
    title: '経費出金願い',
    description: '薬剤師会の経費出金申請はこちらから',
    icon: 'ri-file-text-line',
    link: '#',
    color: 'teal'
  },
  {
    title: '備品申込書',
    description: '備品の申込手続きを行えます',
    icon: 'ri-inbox-line',
    link: '#',
    color: 'amber'
  },
  {
    title: '利用状況確認',
    description: '備品の利用状況を確認できます',
    icon: 'ri-bar-chart-box-line',
    link: '#',
    color: 'teal'
  },
  {
    title: '掲示板',
    description: '会員専用の掲示板はこちら',
    icon: 'ri-message-3-line',
    link: '#',
    color: 'amber'
  },
  {
    title: '研修申請',
    description: '研修の認定単位申請について',
    icon: 'ri-award-line',
    link: '#',
    color: 'teal'
  },
  {
    title: 'JPAL',
    description: '生涯学習支援システム',
    icon: 'ri-graduation-cap-line',
    link: '#',
    color: 'amber'
  }
];

export function Services() {
  return (
    <section id="services" className="py-32 bg-white relative overflow-hidden">
      <div className="absolute top-20 right-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">
            SERVICES
          </p>
          <h2 className="text-5xl font-bold text-slate-900">
            会員向けサービス <span className="text-teal-600">&amp; リンク</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 cursor-pointer"
            >
              <div className={`w-20 h-20 flex items-center justify-center rounded-2xl mb-6 ${
                service.color === 'teal' ? 'bg-teal-500/10' : 'bg-amber-500/10'
              }`}>
                <i className={`${service.icon} text-4xl ${
                  service.color === 'teal' ? 'text-teal-600' : 'text-amber-600'
                }`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 text-base mb-4">
                {service.description}
              </p>
              <div className="flex items-center text-teal-600 font-medium group-hover:gap-3 gap-2 transition-all">
                <span>こちらをクリック</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
